// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ohscrlnsiuavvlmtlugb.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9oc2NybG5zaXVhdnZsbXRsdWdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA2MTEwNDgsImV4cCI6MjA2NjE4NzA0OH0.xZ-vK3_AyH-1cvdlxBSNcv7P_68Z60G7YgQcDVA-RfI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
